/** Commerce vitrine — no label overrides (uses default i18n keys). */
import type { CatalogCardFieldKey } from '../../types';

export const moduleLabelKeys: Partial<Record<string, string>> = {};

export const groupLabelKeys: Partial<Record<string, string>> = {};

/** Remap i18n keys for brand-specific copy (e.g. products → items). */
export const copyKeyAliases: Record<string, string> = {
  'legal.terms.body': 'legal.terms.body.catalogofworks',
};

/** Card field toggles shown in Settings → Design. */
export const visibleCatalogCardFieldKeys: readonly CatalogCardFieldKey[] = [
  'name',
  'sku',
  'price',
  'stock',
];

/** Storefront profile tab label for guests (not logged in). */
export const guestProfileLabelKey = 'nav.registration';

/** Storefront profile tab label for signed-in clients. */
export const memberProfileLabelKey = 'nav.profile';
